import { z } from 'zod'

import { emailSchema } from './emailSchema'
import { orderIdSchema } from './orderIdSchema'

export const searchOrderFormSchema = z.object({}).merge(emailSchema).merge(orderIdSchema)
